import { PageInfo } from '../types';

export default function getPageInfo(): PageInfo {
  const pageInfo = document.body.dataset?.pageinfo;
  return pageInfo ? JSON.parse(pageInfo) : {};
}
